<template>
  <div class="step-guide">
    <div class="wln-data">
      <!-- <p class="title">WMS数据</p> -->
      <div class="wln-ycc-content">
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/wms.png"
            @click="toOtherPage('/data-import/wms-order')"
            alt
          />
          <span class="text">WMS订单导入</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down.png"
            alt
          />
          <p class="explain-details">
            选择仓库，并导入wms订单
          </p>
        </div>
        <div class="step"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/operating-income.png"
            @click="toOtherPage('/data-import/operating-income')"
            alt
          />
          <span class="text">操作收入计算</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down.png"
            alt
          />
          <p class="explain-details">
            选择仓库、时间，分布计算单量与收入
          </p>
          <!-- <p class="tag">计算单量</p>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down.png"
            alt
          />
          <p class="tag">计算收入</p> -->
        </div>
        <div class="step"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/rental-income.png"
            @click="toOtherPage('/data-import/rental-income')"
            alt
          />
          <span class="text">场租收入</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down.png"
            alt
          />
          <p class="explain-details">
            选择仓库，并点击“实占面积导入”
          </p>
          <!-- <p class="tag">场租收入导入</p> -->
        </div>
        <div class="step"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/express-income.png"
            @click="toOtherPage('/data-import/express-income')"
            alt
          />
          <span class="text">预计快递</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down.png"
            alt
          />
          <p class="explain-details">
            选择日期，并点击“计算”
          </p>
          <!-- <p class="tag">计算</p> -->
        </div>
        <div class="step"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/personnel-pay.png"
            @click="toOtherPage('/data-import/personnel/personnel-pay')"
            alt
          />
          <span class="text">人员支出</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down.png"
            alt
          />
          <p class="explain-details">
            选择仓库、部门、日期，搜索结果，如需计算请点击“重新计算”
          </p>
          <!-- <p class="tag">导入</p> -->
        </div>
        <div class="step"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/expenses.png"
            @click="toOtherPage('/data-import/expenses')"
            alt
          />
          <span class="text">相关费用</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down.png"
            alt
          />
          <p class="explain-details">
            选择仓库、日期，并点击“费用导入”，需每月一次
          </p>
          <!-- <p class="tag">每月导入</p> -->
        </div>
      </div>
    </div>
    <!-- <div class="ycc-data">
      <p class="title">易仓储数据</p>
      <div class="wln-ycc-content">
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/rental-income2.png"
            @click="toOtherPage('/data-import/rental-income')"
            alt
          />
          <span class="text">场租导入</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down2.png"
            alt
          />
          <p class="tag">场租收入导入</p>
        </div>
        <div class="step2"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/income-expenditure.png"
            @click="toOtherPage('/data-import/express-income?type=ycc')"
            alt
          />
          <span class="text">物流导入</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down2.png"
            alt
          />
          <p class="tag">市内配送导入</p>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down2.png"
            alt
          />
          <p class="tag">物流收入</p>
        </div>
        <div class="step2"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/operating.png"
            @click="toOtherPage('/data-import/operating-income?type=ycc')"
            alt
          />
          <span class="text">操作收入导入</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down2.png"
            alt
          />
          <p class="tag">导入</p>
        </div>
        <div class="step2"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/personnel-pay2.png"
            @click="toOtherPage('/data-import/personnel/personnel-pay')"
            alt
          />
          <span class="text">人员支出</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down2.png"
            alt
          />
          <p class="tag">导入</p>
        </div>
        <div class="step2"></div>
        <div class="explain">
          <img
            class="img"
            src="../../../../assets/images/step-guide/expenses2.png"
            @click="toOtherPage('/data-import/expenses')"
            alt
          />
          <span class="text">相关费用</span>
          <img
            class="icon"
            src="../../../../assets/images/step-guide/down2.png"
            alt
          />
          <p class="tag">每月导入</p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  methods: {
    toOtherPage(url) {
      this.$router.push(url);
    }
  }
};
</script>
<style lang="scss" scoped>
.step-guide {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  // .title {
  //   font-size: 16px;
  //   font-weight: bold;
  //   color: rgba(51, 51, 51, 1);
  //   margin-bottom: 16px;
  // }
  .wln-ycc-content {
    display: flex;
    width: 100%;
    // padding-top: 20px;
    // padding-left: 76px;
    .explain {
      width: 16.66%;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      color: #666666;
      .img {
        margin-bottom: 16px;
        cursor: pointer;
      }
      .text {
        letter-spacing: 0;
      }
      .icon {
        margin: 10px 0;
      }
      .tag {
        line-height: 36px;
        text-align: center;
        height: 36px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(210, 210, 210, 1);
        opacity: 0.8;
        border-radius: 18px;
        min-width: 88px;
        padding: 0 6px;
      }
      .explain-details {
        width: 90%;
        height: 120px;
        line-height: 18px;
        font-size: 14px;
        border-radius: 4px;
        font-weight: 400;
        color: #666666;
        background: rgb(247, 247, 247);
        padding: 10px 10px 0px 10px;
        box-sizing: border-box;
      }
      @media screen  and (max-width:1115px){
        .explain-details {
          height: 200px;
        }
      }
    }
    .step {
      width: 44px;
      height: 24px;
      margin: 32px 3px;
      background: url(../../../../assets/images/step-guide/step.png) center center
        no-repeat;
    }
    .step2 {
      width: 44px;
      height: 24px;
      margin: 32px 3px;
      background: url(../../../../assets/images/step-guide/step2.png) center center
        no-repeat;
    }
  }
  .wln-data {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    // height: 386px;
    // background: rgba(255, 255, 255, 1);
    // margin-bottom: 16px;
    padding: 16px;
    box-sizing: border-box;
  }
  // .ycc-data {
  //   height: 386px;
  //   background: rgba(255, 255, 255, 1);
  //   border-radius: 4px;
  //   padding: 16px;
  //   box-sizing: border-box;
  // }
}
</style>
